// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/subscribedSubsites';

export type SubscribedSubsites = {
  subsiteIds: string[];
};
export type State = SubscribedSubsites;
export default function subscribedSubsites(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    subsiteIds: [],
  },
  action: Action
) {
  switch (action.type) {
    case 'ADD_SUBSCRIBED_SUBSITE': {
      const { subsiteId } = action;
      return { ...state, subsiteIds: [...state.subsiteIds, subsiteId] };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
